/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetProcessingStatusQueryResponse, DocumentUseCasesControllerGetProcessingStatusPathParams, DocumentUseCasesControllerGetProcessingStatus400, DocumentUseCasesControllerGetProcessingStatus401, DocumentUseCasesControllerGetProcessingStatus403, DocumentUseCasesControllerGetProcessingStatus404 } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetProcessingStatus";

function getDocumentUseCasesControllerGetProcessingStatusUrl(id: DocumentUseCasesControllerGetProcessingStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing-status` as const }  
  return res
}

/**
 * @description Returns current processing status and progress for a document as a read-only resource
 * @summary Get document processing status
 * {@link /api/v1/documents/:id/processing-status}
 */
export async function documentUseCasesControllerGetProcessingStatus(id: DocumentUseCasesControllerGetProcessingStatusPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerGetProcessingStatusQueryResponse, ResponseErrorConfig<DocumentUseCasesControllerGetProcessingStatus400 | DocumentUseCasesControllerGetProcessingStatus401 | DocumentUseCasesControllerGetProcessingStatus403 | DocumentUseCasesControllerGetProcessingStatus404>, unknown>({ method : "GET", url : getDocumentUseCasesControllerGetProcessingStatusUrl(id).url.toString(), ... requestConfig })  
  return res.data
}